// generateSimpleId: will be used while we don't have an id from backend
export function generateSimpleId (): string {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
}
